import { useEffect } from 'react'

export type Ground = 'candy' | 'calm' | 'plain'

/**
 * The ground behind a screen. Photograph-led screens sit on the full candy
 * gradient with its colour blobs; dense lists and settings ask for a calmer
 * one so the text stays easy to read. The attribute lives on the root element
 * because the ground is painted by the body, behind every screen.
 */
export function useGround(ground: Ground) {
  useEffect(() => {
    const root = document.documentElement
    if (ground === 'candy') delete root.dataset.ground
    else root.dataset.ground = ground
    return () => {
      delete root.dataset.ground
    }
  }, [ground])
}
